/** Potter's production icons; base input retains send and speech behavior. */
import InputBar from "../../../components/base/InputBar.js";
import { getTheme } from "../../../core/configAccessors.js";
import micIcon from "../assets/mic.svg";
import sendIcon from "../assets/send.svg";

export default class PottersInputBar extends InputBar {
  render() {
    const bar = super.render();
    bar.querySelector(".ws-btn-send").innerHTML = sendIcon;
    const mic = bar.querySelector(".ws-btn-mic");
    if (mic && !getTheme("mic_icon_url", null)) mic.innerHTML = micIcon;
    return bar;
  }
}
